module.exports = __webpack_public_path__ + "media/audio7.673c04d0.mp3";